import { render, staticRenderFns } from "./InstructorSchedule.vue?vue&type=template&id=e64a918e&scoped=true"
import script from "./InstructorSchedule.vue?vue&type=script&lang=js"
export * from "./InstructorSchedule.vue?vue&type=script&lang=js"
import style0 from "./InstructorSchedule.vue?vue&type=style&index=0&id=e64a918e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64a918e",
  null
  
)

export default component.exports